/**
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
'use strict';

import PropTypes from 'prop-types';

import React from 'react';

export default {
    executeAction: PropTypes.func.isRequired,
    getStore: PropTypes.func.isRequired
};
